import React from 'react';
import {Badge} from '@sail/ui';

const basic = {
  rendered: (
    <>
      <Badge>Default</Badge>
      <Badge type="info">Info</Badge>
      <Badge type="positive">Positive</Badge>
      <Badge type="negative">Negative</Badge>
      <Badge type="warning">Warning</Badge>
      <Badge type="urgent">Urgent</Badge>
    </>
  ),
  source: `<Badge>
  Default
</Badge>

<Badge type="info">
  Info
</Badge>

<Badge type="positive">
  Positive
</Badge>

<Badge type="negative">
  Negative
</Badge>

<Badge type="warning">
  Warning
</Badge>

<Badge type="urgent">
  Urgent
</Badge>`,
};

export const BadgeExamples = {basic};
